<template>
  <WdsSelect
    v-model="vmodel"
    class="tw-w-full"
    :list="list"
    :placeholder="$t('Select option to filter by')"
  />
</template>

<script lang="ts" setup>
import { WdsSelect } from '@worksome/wds-components'
import { computed } from 'vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const props = defineProps<{ list: { value: string; label: string }[] }>()

const model = defineModel<string | null>()

const vmodel = computed({
  get() {
    return model.value ? props.list.find(({ value }) => value === model.value) : null
  },
  set({ value }: { value: string; label: string }) {
    model.value = value
  },
})
</script>
